/** users.status */
export const UserStatus = {
    INVITED: 'INVITED',
    ACTIVE: 'ACTIVE',
    DEACTIVATED: 'DEACTIVATED',
};
/** tasks.status */
export const TaskStatus = {
    DRAFT: 'DRAFT',
    PENDING: 'PENDING',
    ONGOING: 'ONGOING',
    BLOCKED: 'BLOCKED',
    DONE: 'DONE',
    CANCELLED: 'CANCELLED',
};
/** tasks.priority */
export const TaskPriority = {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW',
};
/**
 * tasks.completion_policy - when a task with several assignees flips to DONE.
 * LEAD_ONLY means only the assignee flagged is_lead can close it.
 */
export const CompletionPolicy = {
    ANY: 'ANY',
    ALL: 'ALL',
    LEAD_ONLY: 'LEAD_ONLY',
};
/** tasks.cancel_reason */
export const CancelReason = {
    NO_LONGER_NEEDED: 'NO_LONGER_NEEDED',
    DUPLICATE: 'DUPLICATE',
    DONE_ANOTHER_WAY: 'DONE_ANOTHER_WAY',
    POSTPONED: 'POSTPONED',
};
export const TASK_STATUS_LABEL = {
    DRAFT: 'Draft',
    PENDING: 'Not started',
    ONGOING: 'In progress',
    BLOCKED: 'Blocked',
    DONE: 'Completed',
    CANCELLED: 'On hold',
};
export const USER_STATUS_LABEL = {
    INVITED: 'Invited',
    ACTIVE: 'Active',
    DEACTIVATED: 'Deactivated',
};
export const TASK_PRIORITY_LABEL = {
    HIGH: 'High',
    MEDIUM: 'Medium',
    LOW: 'Low',
};
/** Convenience for dropdowns, so no second list is hand-maintained. */
export const TASK_STATUSES = Object.values(TaskStatus);
export const TASK_PRIORITIES = Object.values(TaskPriority);
export const USER_STATUSES = Object.values(UserStatus);
//# sourceMappingURL=enums.js.map